export default function GS_Single_Color_Formatting() {
  return (
    <div className="p-4">
      <h1>GS Single Color Formatting</h1>
    </div>
  );
}
